import React from 'react';
import Footer from 'containers/footer';
import { Link, generatePath } from 'react-router-dom';
import routes from 'globals/routes';
import {useDataValue} from 'globals/contexts/dataContext';

import './privacyPage.css';

const PrivacyPage = () => {
  const [{content, currentLanguage}] = useDataValue();
  const logoUrl = content['logo'];

  const pageContent = content['content'][currentLanguage]['privacy'];
  return <div id="privacy" className="page">
    <div className="landing">
      <div className="logo">
        <Link to={generatePath(routes.indexPage, {lang: currentLanguage})}>
          <img src={logoUrl} />
        </Link>
      </div>
    </div>
    <section class="privacyPolicy" dangerouslySetInnerHTML={{
      __html: pageContent
    }} />
    <Footer />
  </div>;
}
export default PrivacyPage;